import PropTypes from 'prop-types';

import { StatusBadge } from '#/modules/commonComponents/badge';
import {
  formatSignReceiptStatusLabel,
} from '#/modules/crmMgmt/aftersales/signReceipt/helper/signReceiptStatus';

const SignReceiptStatusBadge = ({ status, size = 'default', className }) => (
  <StatusBadge
    status={status}
    label={formatSignReceiptStatusLabel(status)}
    size={size}
    className={className}
  />
);

SignReceiptStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
};

export default SignReceiptStatusBadge;
